import { render, staticRenderFns } from "./DetailsCourseAddEditCourseModal.vue?vue&type=template&id=17009841&scoped=true&"
import script from "./DetailsCourseAddEditCourseModal.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseAddEditCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17009841",
  null
  
)

export default component.exports